<script lang="ts" module>
  import NavButton from '@/ui/elements/buttons/NavButton.svelte';
  import { useActiveText, useTeoCore } from '@/utils/teo-context';
  import { useAnalysisState } from '@/utils/teo-context/teo-atoms/analysis';
  import { useActiveTextUIView } from '@/utils/teo-context/teo-atoms/text';
</script>

<script lang="ts">
  const analysisState = useAnalysisState();
  const teoCore = useTeoCore();
  const activeText = useActiveText();
  const [selectedView, setSelectedView] = useActiveTextUIView();

  function gotoVersions() {
    setSelectedView('versions');
  }

  const handleClick = $derived(() => {
    const needsAnalysis = !analysisState.current.isCurrent;

    if (needsAnalysis) {
      const notificationNeedsAnalysis = teoCore.notifications.add({
        title: 'Versionen',
        message: `Der aktuelle Text wurde noch nicht zur Versionshistorie hinzugefügt. 
           Hierzu muss zunächst eine Analyse durchgeführt werden.`,
        mode: 'warning',
        buttons: [
          {
            label: 'Abbrechen',
            variant: 'secondary',
            onclick: () => {
              teoCore.notifications.close(notificationNeedsAnalysis);
            },
          },
          {
            label: 'Analyse starten',
            variant: 'primary',
            onclick: () => {
              activeText.current
                .analyze()
                .then(() => {
                  teoCore.notifications.close(notificationNeedsAnalysis);
                  gotoVersions();
                })
                .catch(() => {
                  teoCore.notifications.close(notificationNeedsAnalysis);
                });
              return 'keep';
            },
          },
        ],
      });
    } else {
      gotoVersions();
    }
  });
</script>

<NavButton
  label="Versionen"
  icon="History"
  onclick={handleClick}
  selected={selectedView.current == 'versions'}
  disabled={!analysisState.current.canAnalyze}
/>
